import React from "react";
import { Wrapper, RatingList } from "../components/Wrapper";
import { Title } from "../components/Text";
import { RatingItem } from "../components/RatingItem";

const RatingsModule = ({ rateData }) => {
  return (
    <RatingList sx={{ height: "100%", overflow: "auto" }}>
      {rateData?.rates?.map((rate) => (
        <RatingItem
          key={rate.user_id}
          name={rate.user_name}
          description={rate.comment}
          ratingValue={rate.rataing}
        />
      ))}
    </RatingList>
  );
};

export default RatingsModule;
